module.exports = "pegasus_template/assets/themecapture1/charity/104.png";